// extracted by mini-css-extract-plugin
module.exports = {"container":"Users_container__2LVjz","wrapper":"Users_wrapper__3ANht","header":"Users_header__2eW2w","empty-results":"Users_empty-results__vS-lu"};